import httpService from '@/utils/request'
import { contextPath } from '@/config/'


export const uploadFileApi = (params,data) => {
  return httpService({
    url: contextPath + '/common/file/item/uploadFile',
    method: 'post',
    params,
    data,
    apiType: 'file'
  })
}

export const getFileUrlApi = (params,data) => {
  return httpService({
    url: contextPath + '/common/file/item/getUrl',
    method: 'get',
    params,
    data
  })
}
